import { render, staticRenderFns } from "./SelectOption.vue?vue&type=template&id=24d8eecb&scoped=true"
import script from "./SelectOption.vue?vue&type=script&lang=js"
export * from "./SelectOption.vue?vue&type=script&lang=js"
import style0 from "./SelectOption.vue?vue&type=style&index=0&id=24d8eecb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d8eecb",
  null
  
)

export default component.exports